<div class="p-4 rounded-xl">
  <!-- HEADER -->
  <div class="flex justify-between items-center mb-4">
    <div>
      <h2 class="text-lg font-semibold">{{ 'QUESTIONNAIRE.QUESTION_SETUP.TITLE' | translate }}</h2>
      <p class="text-sm text-gray-500" *ngIf="qstnrSeq">{{ 'QUESTIONNAIRE.QUESTION_SETUP.QUESTIONNAIRE_ID' | translate: { id: qstnrSeq } }}</p>
    </div>

    <div class="flex gap-10 items-center ">
      <button class="btn-primary" (click)="openPopup()">{{ 'QUESTIONNAIRE.QUESTION_SETUP.ADD_QUESTION' | translate }}</button>
      <app-back-button></app-back-button>
    </div>
  </div>

  <!-- TABLE -->
  <app-table [columns]="columns" [data]="list" [actions]="actions"[enablePagination]="true"></app-table>

  <!-- POPUP -->
  <app-popup
    [(show)]="showPopup"
    title="QUESTIONNAIRE.QUESTION_SETUP.TITLE"
    [fields]="fields"
    [data]="formData"
    [onSave]="handleSave"
    type="form"
  ></app-popup>
</div>
